import { ChevronRight } from "lucide-react";
import { Link } from "react-router";
import {Race, RaceStatus} from "@/backend/domain/models/race";
import {formatDateTime} from "@/lib/utils";

type Props = {
    races: Race[];
}

export function RaceCalendar({races} : Props) {

    const raceStatusMap : Record<RaceStatus, string> = {
        'REGISTRATION_OPEN' : 'Anmeldung offen',
        'REGISTRATION_CLOSED' : 'Anmeldung geschlossen',
        'DRAFT' : 'Entwurf',
        'COMPLETED' : 'Abgeschlossen'
    }

    const mappedRaces = races.map(race => {
        return {
            ...race,
            formattedRace : formatDateTime(race.date as unknown as string),
            raceStatusFormatted : raceStatusMap[race.status]
        }
    })

    return (
        <section id="race-calendar" className="bg-slate-900 text-white py-24">
            <div className="max-w-6xl mx-auto px-6">
                <h2 className="text-3xl font-light tracking-wider mb-12">RENNKALENDER</h2>
                <div className="grid gap-6">
                    {mappedRaces.map((race, i) => (
                        <Link to={`/race/${race.id}`} key={i}>
                            <div
                                className="group cursor-pointer border-t border-white/10 py-6 hover:bg-slate-800/50 transition-colors">
                                <div className="grid md:grid-cols-[1fr,2fr,1fr] gap-8">
                                    <div
                                        className="text-2xl font-light">{race.formattedRace.date} {race.formattedRace.time}</div>
                                    <div>
                                        <div className="font-light tracking-wider mb-2">{race.name}</div>
                                    </div>
                                    <div className="flex justify-between items-center">
                   <span
                       className={`text-sm ${race.status === 'REGISTRATION_OPEN' ? 'text-green-600' : 'text-slate-500'}`}>
                     {race.raceStatusFormatted}
                   </span>
                                        <ChevronRight className="opacity-0 group-hover:opacity-100 transition-opacity"/>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
